import sum from 'lodash.sum';

export function totalCartItems(allItems) {
  return sum(allItems?.map((item) => item.total) ?? []);
}
